import React, { useContext, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../../utils/api';
import { SprawneMiastoContext } from '../../components/SprawneMiastoContext';
import { BiLoaderAlt } from 'react-icons/bi';
import { MdDone, MdErrorOutline } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

export default function Assign() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const Context = useContext(SprawneMiastoContext);
    const { t } = useTranslation();
    const [assigningStatus, setAssigningStatus] = useState<'assigned' | 'assigning' | 'failed'>(
        'assigned',
    );

    async function assignDistrict() {
        console.log(token);
        if (!token) return setAssigningStatus('failed');

        const response = await api.post('adminpanel/districts/token', {
            body: JSON.stringify({ token: token }),
        });
        console.log(response);
        if (response.ok) {
            Context?.fetchUser();
            return setAssigningStatus('assigned');
        }
        return setAssigningStatus('failed');
    }

    useEffect(() => {
        assignDistrict();
    }, []);

    return (
        <div className={'flex min-h-[calc(100vh-72px)] flex-col items-center justify-center gap-2'}>
            {assigningStatus === 'assigning' && (
                <>
                    <div className={'animate-spin-slow'}>
                        <BiLoaderAlt className={'text-6xl text-SM-yellow'} />
                    </div>
                    <h2 className={'text-center'}>{t('translation:ASSIGN_USER.JOINING')}</h2>
                </>
            )}

            {assigningStatus === 'failed' && (
                <>
                    <div>
                        <MdErrorOutline className={'text-6xl text-red-600'} />
                    </div>
                    <h2 className={'text-center'}>{t('translation:ASSIGN_USER.JOINING_FAILED')}</h2>
                    <Link to={'/'}>
                        <button className={'btn-filled bg-red-600 text-white ring-red-600/50'}>
                            {t('translation:ASSIGN_USER.RETURN_TO_MAIN_PAGE')}
                        </button>
                    </Link>
                </>
            )}

            {assigningStatus === 'failed' && (
                <>
                    <div>
                        <MdDone className={'text-6xl text-green-600'} />
                    </div>
                    <h2 className={'text-center'}>{t('translation:ASSIGN_USER.JOINED')}</h2>
                    <div className={'flex justify-center gap-4'}>
                        <Link to={'/'}>
                            <button
                                className={'btn-filled bg-green-600 text-white ring-green-600/50'}>
                                {t('translation:ASSIGN_USER.RETURN_TO_MAIN_PAGE')}
                            </button>
                        </Link>
                        <Link to={'/adminCenter'}>
                            <button
                                className={'btn-filled bg-SM-yellow text-white ring-SM-yellow/50'}>
                                {t('translation:ASSIGN_USER.GO_TO_ADMIN_CENTER')}
                            </button>
                        </Link>
                    </div>
                </>
            )}
        </div>
    );
}
